// ** Initial State
const initialState = {
  allChapters: [],
  chapters: [],
  allLessons: [],
  lessons: [],
  allMaterials: [],
  materials: [],
  total: 1,
  params: {},
  selectedMaterial: null,
  selectedLesson: null,
  selectedChapter: null,
};

const materials = (state = initialState, action) => {
  switch (action.type) {
    case "EMPTY_REDUCER":
      return initialState;
    case "GET_ALL_CHAPTERS":
      return { ...state, allChapters: action.data };
    case "GET_CHAPTERS":
      return {
        ...state,
        chapters: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case "GET_ALL_LESSONS":
      return { ...state, allLessons: action.data };
    case "GET_LESSONS":
      return {
        ...state,
        lessons: action.data,
        total: action.totalPages,
        params: action.params,
      };
    case "GET_ALL_MATERIALS":
      return { ...state, allMaterials: action.data };
    case "GET_MATERIALS":
      return {
        ...state,
        materials: action.data,
        total: action.totalPages,
        params: action.params,
      };

    case "ADD_CHAPTER":
      return { ...state };
    case "ADD_LESSON":
      return { ...state };
    case "ADD_MATERIAL":
      return { ...state };
    case "DELETE":
      return { ...state };
    case "GET_MATERIAL":
      return { ...state, selectedMaterial: action.selectedMaterial };
    case "UPDATE_MATERIAL":
      return { ...state };
    case "GET_LESSON":
      return { ...state, selectedLesson: action.selectedLesson };
    case "UPDATE_LESSON":
      return { ...state };
    case "GET_CHAPTER":
      return { ...state, selectedChapter: action.selectedChapter };
    case "UPDATE_CHAPTER":
      return { ...state };
    case "GET_ALL_DATA":
      return { ...state, allData: action.data };
    case "GET_DATA":
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
      };
    // case "GET_USER":
    //   return { ...state, selectedUser: action.selectedUser };
    case "ADD_USER":
      return { ...state };
    case "DELETE_USER":
      return { ...state };
    case "UPDATE_USER":
      return { ...state };
    default:
      return { ...state };
  }
};
export default materials;
